import { useEffect } from 'react';
import {
  MESSAGE_EVENTS,
  postStorefrontOverlayAddPageItem,
} from 'components/storefront/editor/utils/post-message';

export default function SwellPicker(data) {
  /** @param {MessageEvent} event */
  const eventListener = (event) => {
    switch (event.data.type) {
      case MESSAGE_EVENTS.STOREFRONT_EDITOR.OVERLAY.CLOSED:
        return data.onClose();

      default:
        return;
    }
  };

  useEffect(() => {
    const { domRect, path } = data;

    postStorefrontOverlayAddPageItem(domRect || {}, path);

    window.addEventListener('message', eventListener);
    return () => {
      window.removeEventListener('message', eventListener);
    };
  }, []);

  return null;
}
